import { STATUSES } from './constants'

 // Generic function to get the updated status for the order
export const getUpdatedStatus = (orderDelivery, command, materials, isDriver) => {
    const isComplete =
      command?.status === STATUSES.COMPLETE &&
      orderDelivery.deliveryDate &&
      (orderDelivery.startingSiteBdnId || orderDelivery.startingSiteId || orderDelivery.startingSiteAddress) &&
      (orderDelivery.deliverySiteBdnId || orderDelivery.deliverySiteId || orderDelivery.deliverySiteAddress) &&
      (materials.length > 0);
  
    const isPlanified = isComplete && isDriver;
    const isValid =
      isComplete &&
      orderDelivery.scanCmr &&
      orderDelivery.scanProviderDeliveryNote &&
      orderDelivery.scanSignature;
  
    let orderForSave = { ...orderDelivery };
    if (isComplete && ![STATUSES.VALID, STATUSES.CANCELED].includes(orderForSave.status)) {
      orderForSave.status = STATUSES.COMPLETE;
    }
  
    if (isPlanified && ![STATUSES.VALID, STATUSES.CANCELED].includes(orderForSave.status)) {
      orderForSave.status = STATUSES.PLANIFIED;
    }
  
    if (isValid && orderForSave.status !== STATUSES.CANCELED) {
      orderForSave.status = STATUSES.VALID;
    }
  
    return orderForSave.status;
  };
  
